import { ListChecks, ToggleLeft, PencilLine, TextCursorInput } from 'lucide-react';

import Container from '../../Main/sections/Container';
import Reveal from '../../../components/Reveal';

const TYPES = [
  {
    icon: ListChecks,
    color: '#5ED8B2',
    title: 'Multiple Choice',
    body: "Four options, one correct answer. Classic format that's proven to reinforce recall under exam conditions.",
  },
  {
    icon: ToggleLeft,
    color: '#a78bfa',
    title: 'True / False',
    body: 'Fast-fire statements to check conceptual understanding. Great for warming up before deeper study.',
  },
  {
    icon: PencilLine,
    color: '#f472b6',
    title: 'Short Answer',
    body: 'Type your own response. AI grades it instantly and compares it to the ideal answer with a similarity score.',
  },
  {
    icon: TextCursorInput,
    color: '#fb923c',
    title: 'Fill in the Blank',
    body: 'Key terms removed from context sentences. Forces active recall rather than passive recognition.',
  },
];

const QuestionTypes = () => {
  return (
    <section className="relative py-20 lg:py-24">
      <Container>
        <Reveal className="text-center">
          <span className="eyebrow">Question Types</span>
          <h2 className="font-heading mx-auto mt-5 max-w-3xl text-[2rem] font-bold leading-[1.1] sm:text-[2.6rem] lg:text-[3rem]">
            <span className="head-fade">4 Ways To </span>
            <span className="text-accent-grad">Test Your Knowledge</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[0.95rem] text-white/55">
            School Hack generates multiple question formats so you're never
            drilling the same way twice — keeping your brain sharp and focused.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {TYPES.map((t, i) => (
            <Reveal key={t.title} delay={i * 90}>
              <div className="glass glass-hover h-full rounded-2xl p-6 text-center">
                <span
                  className="mx-auto flex h-11 w-11 items-center justify-center rounded-xl"
                  style={{ background: `${t.color}1f`, color: t.color }}
                >
                  <t.icon size={22} />
                </span>
                <h3 className="font-heading mt-5 text-[1.15rem] font-semibold text-white">
                  {t.title}
                </h3>
                <p className="mt-2 text-[0.86rem] leading-relaxed text-white/55">
                  {t.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default QuestionTypes;
